import { Reveal, StaggerGroup, StaggerItem } from "../site/Motion";
import { SectionLabel, Icon } from "../site/Bits";
import { FEATURES } from "../../lib/site";

export const Features = () => (
  <section id="features" className="relative scroll-mt-24 bg-background py-24" data-testid="features-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="max-w-2xl">
        <SectionLabel>Key features</SectionLabel>
        <h2 className="mt-5 font-display text-4xl font-bold leading-tight tracking-tight text-ink sm:text-5xl">
          Everything you need to stay ahead of renewals.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-slate-600">
          Purpose-built tools that turn scattered deadlines into a calm, controlled workflow.
        </p>
      </Reveal>

      <StaggerGroup className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {FEATURES.map((f) => (
          <StaggerItem key={f.title}>
            <div
              data-testid={`feature-${f.title.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className="group h-full rounded-3xl border border-slate-200 bg-white p-8 shadow-sm transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:border-brand/20 hover:shadow-xl"
            >
              <span className="grid h-12 w-12 place-items-center rounded-2xl bg-brand/5 text-brand transition-colors duration-300 group-hover:bg-brand group-hover:text-white">
                <Icon name={f.icon} className="h-6 w-6" />
              </span>
              <h3 className="mt-6 font-display text-xl font-semibold text-ink">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{f.desc}</p>
            </div>
          </StaggerItem>
        ))}
      </StaggerGroup>
    </div>
  </section>
);

export default Features;
